import * as React from 'react';
import { TextInput } from "soprasteria-ui-library";
import { IPatient } from '../../../models/IPatient';
import { IRiskPotReport } from '../../../models/IRiskPotReport';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";

interface IRiskPotReportInformation {
    riskPotReport: IRiskPotReport;
    patient: IPatient;
}

export const RiskPotReportInformation: React.FunctionComponent<IRiskPotReportInformation> = ({ patient, riskPotReport }) => {

    const formatAddress = (street?: string, zipCode?: string, city?: string): string => {
        if (undefinedOrEmpty(street) || undefinedOrEmpty(zipCode) || undefinedOrEmpty(city)) {
            return "Saknas";
        }
        return `${street?.trim()}, ${zipCode} ${city}`;
    }

    const undefinedOrEmpty = (value: string | undefined): boolean => {
        return value === undefined || value === "" || value === null;
    }

    const setDefaultValue = (value: string | undefined) => {
        return (value === undefined || value === null || value.length == 0) ? "Saknas" : value;
    }

    return (
        <section>
            <div className="row">
                <div className="col-6">
                    <TextInput name="assessmentPeriodReadonly"
                        label="Prövningsperiod"
                        defaultValue={`${dateTimeToDateString(riskPotReport.assessmentStartDate)} - ${dateTimeToDateString(riskPotReport.assessmentEndDate)}`}
                        readonly
                        inlineLabel />
                </div>
            </div>
            <hr />
            <div className="row readonly-less-margin">
                <h5 className="col-12">Patientinformation</h5>
                <div className="col-6">
                    <TextInput name="pnrReadonly" label="Personnummer" defaultValue={formatPersonalSecurityNumberAndOrganisationNumber(patient.personalSecurityNumber)} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="addressReadonly" label="Adress" defaultValue={formatAddress(patient.address.address, patient.address.zipCode, patient.address.city)} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="patientPhoneNumber" label="Telefon" defaultValue={setDefaultValue(patient.phoneNumber)} inlineLabel readonly />
                </div>
            </div>
            <hr />
            <div className="row readonly-less-margin">
                <h5 className="col-12">Mottagningsinformation</h5>
                <div className="col-6">
                    <TextInput name="readonly" label="Vårdgivare" defaultValue={riskPotReport.careProvider.displayOrganisationInformation} inlineLabel readonly />
                    <TextInput name="readonly" label="Adress" defaultValue={formatAddress(riskPotReport.careProvider.address?.address, riskPotReport.careProvider.address?.zipCode, riskPotReport.careProvider.address?.city)} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="readonly" label="Mottagning" defaultValue={riskPotReport.careProvider.displayCareProviderName} inlineLabel readonly />                    
                </div>
            </div>
            <hr />
        </section>
    )
}